import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import FotterMain from '../BaseComponents/FotterMain'
import Header from '../BaseComponents/Header'

const ReturnPolicy = () => {
    const toTop = () => {
        window.scrollTo(0, 0);
      }
      useEffect(() => {
        toTop();
      }, []);
    return (
        <>
          <Helmet>
                <title>RETURN POLICY</title>
            </Helmet>
            <Header />
            <div className='innerpagebg pt-5 pb-5'>
                <div className='container mb-4'>
                    <div className='row'>
                        <div className='col-12  m-auto'>
                            <div className="align-items-center text-left">
                                <h4 className='d-inline-block m-0 fw-bold text-uppercase'>
                                    <span className='txtred'>RETURN</span> <span className='txtdgray'>& REFUND POLICY</span>
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='container'>
                    <div className='row '>
                        <div className='col-lg-12 col-mg-12 col-sm-12 col-12 text-start m-auto'>
                            <div className='card p-3 rounded-0 shadow-sm pt-3'>
                                <p>Thank you for visiting www.hondaindiapower.com. The following terms are applicable to any products
                                    that has been purchased from the online store of the Company.</p>
                                <ul className='ps-3'>
                                    <li><strong>How Cancellation &amp; Refund Works?</strong>
                                        <p>You can easily cancel your order anytime until the invoice is generated. The cancelled order amount will be credited back within 7 to 10 working days to the source account in the same mode as the payment was made. No Cancellation or request for refund will be entertained once the invoice is generated.</p>
                                        <p><i>In the case of EMI cancelled orders, the refund process will include the deduction of the applicable interest amount in accordance with the standards set by the bank.</i></p>
                                    </li>
                                    <li><strong>How a Product is replaced ?</strong>
                                        <p>In the event of failure of the product due to some manufacturing defect, provided that such failure is promptly reported to the Company/its Dealer and the Customer provides all information that may be necessary to assist us in resolving the defect, the Company /its authorized dealer will promptly as reasonably practicable repair the affected product in accordance with the terms of the product warranty. However, obligation to repair or replace defective products shall not apply to any product that has been subjected to neglect and/or has not been maintained as per the instructions prescribed in the warranty manual.</p>
                                    </li>
                                    <li><strong>Customer Support/Contact Us</strong>
                                        <p>Call on Toll free customer service number 1800-11-2323 to visit your nearest Honda authorized dealer.
                                            Alternatively, you can also contact your nearest Honda dealer by following the link:
                                            <Link to="/service-network">https://www.hondaindiapower.com/service-network.</Link></p>
                                    </li>
                                </ul>
                                <p>
                                For any queries or concerns relating to the return and cancellation, kindly reach out to our customer support team at:<br />
                                <strong>By Email:</strong> customer.support@hipp.co.in<br/>
                                <strong>By Call:</strong> 1800-11-2323 (Mon-Sun 09:00 AM - 06:00 PM)
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FotterMain />

        </>
    )
}

export default ReturnPolicy